export const NO_QUERY = 'no-query'
